import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AzureAuthService, DtisShellComponent } from '@dtis/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { environment } from '../environments/environment';

/**
 * AppComponent is the root component for the dtis-admin application.
 *
 * - Handles authentication using AzureAuthService.
 * - Configures the navigation slim bar with routes.
 * - On initialization, logs the authentication account and searches for a user by email using UserAzureGraphService.
 *
 * @remarks
 * This component demonstrates integration with Azure authentication and Microsoft Graph API user search.
 */
@Component({
  imports: [RouterModule, DtisShellComponent, TranslocoModule],
  selector: 'dtis-admin-root',
  template: ` <dtis-shell
    [railConfig]="railConfig"
    [header_links]="headerLinks"
    [title]="'DTIS Admin'"
    [appVersion]="appVersion"
  ></dtis-shell>`,
})
export class AppComponent {
  /** Azure authentication service instance */
  auth = inject(AzureAuthService);
  appVersion = environment.version;

  /** Application title */
  title = 'dtis-admin';

  /** Slim bar navigation configuration */
  railConfig = {
    isHidden: false,
    routes: [
      {
        name: 'dashboard',
        icon: 'dashboard',
        route: ['/'],
        exactMatch: true,
      },
      {
        name: 'BU Management',
        icon: 'business',
        route: ['/business-unit-management'],
      },
    ],
  };

  headerLinks = [];
}
